'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp; /**
                    * Created by lyj on 2016/4/19.
                    */


var _react = require('react');

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var GoeasyInputField = (_temp = _class = function (_Component) {
  (0, _inherits3.default)(GoeasyInputField, _Component);

  // keyDown: PropTypes.func

  function GoeasyInputField() {
    (0, _classCallCheck3.default)(this, GoeasyInputField);
    return (0, _possibleConstructorReturn3.default)(this, (0, _getPrototypeOf2.default)(GoeasyInputField).call(this));
  }

  (0, _createClass3.default)(GoeasyInputField, [{
    key: 'onAfterInit',
    value: function onAfterInit() {
      var _props = this.props;
      var afterInit = _props.afterInit;
      var productId = _props.productId;

      if (afterInit) {
        afterInit(this.refs.ordertextarea.value, productId);
      }
    }

    /*
     handleKeyDown(event) {
     const { keyDown } = this.props;
     if (keyDown) {
     // console.log(event);
     // console.log(event.keyCode);
     if (event.keyCode === 13) {
     keyDown();
     }
     }
     } */

    /*
     componentDidMount() {
     const {formProps} = this.props;
     if (formProps && formProps.name === 'mobile') {
     console.log(formProps.value);
     }
     }
     onChange(event, oldValue) {
     const {onChange} = this.props;
     if (onChange && event.target.value !== oldValue) {
     onChange(event.target.value);
     }
     }*/

  }, {
    key: 'render',
    value: function render() {
      var styles = require('./GoeasyInputField.scss');
      var _props2 = this.props;
      var label = _props2.label;
      var inputType = _props2.inputType;
      var inputPlaceholder = _props2.inputPlaceholder;
      var labelStyle = _props2.labelStyle;
      var inputStyle = _props2.inputStyle;
      var fieldStyle = _props2.fieldStyle;
      var goeasyStyle = _props2.goeasyStyle;
      var value = _props2.value;
      var disabled = _props2.disabled;
      var formProps = _props2.formProps;
      var orderEvaluate = _props2.orderEvaluate;
      // console.log(formProps);

      var component = '';
      var currentFieldStyle = {};
      if (inputType === 'textarea') {
        if (fieldStyle) {
          currentFieldStyle = (0, _extends3.default)({}, fieldStyle);
        }
        if (disabled) {
          component = _react2.default.createElement(
            'div',
            { className: styles.field + ' ' + styles.inputTextarea,
              style: currentFieldStyle },
            formProps ? formProps.value : value
          );
        } else {
          if (orderEvaluate === 'orderEvaluate') {
            component = _react2.default.createElement('textarea', { className: styles.field + ' ' + styles.inputTextarea, style: currentFieldStyle,
              rows: '3',
              ref: 'ordertextarea',
              onChange: this.onAfterInit.bind(this),
              placeholder: inputPlaceholder ? inputPlaceholder : '' });
          } else {
            component = _react2.default.createElement('textarea', (0, _extends3.default)({ className: styles.field + ' ' + styles.inputTextarea, style: currentFieldStyle }, formProps, {
              rows: '3',
              placeholder: inputPlaceholder ? inputPlaceholder : '' }));
          }
        }
      } else {
        if (fieldStyle) {
          currentFieldStyle = (0, _extends3.default)({}, fieldStyle);
        }
        if (disabled) {
          component = _react2.default.createElement(
            'div',
            { className: styles.field, style: currentFieldStyle },
            formProps ? formProps.value : value
          );
        } else {
          component = _react2.default.createElement('input', (0, _extends3.default)({ type: inputType ? inputType : 'text', className: styles.field, style: currentFieldStyle }, formProps, {
            // onKeyDown={this.handleKeyDown.bind(this)}
            placeholder: inputPlaceholder ? inputPlaceholder : '' }));
        }
      }
      return _react2.default.createElement(
        'div',
        { className: styles.component, style: goeasyStyle },
        _react2.default.createElement(
          'div',
          { className: styles.label,
            style: labelStyle ? labelStyle : { fontSize: '14px' } },
          label ? label : ''
        ),
        _react2.default.createElement(
          'div',
          { className: styles.input, style: inputStyle },
          component
        ),
        _react2.default.createElement('div', { className: 'clear' }),
        formProps && formProps.error && formProps.touched && _react2.default.createElement(
          'div',
          { className: styles.textDanger },
          formProps.error
        )
      );
    }
  }]);
  return GoeasyInputField;
}(_react.Component), _class.propTypes = {
  label: _react.PropTypes.string,
  inputType: _react.PropTypes.string,
  inputPlaceholder: _react.PropTypes.string,
  labelStyle: _react.PropTypes.object,
  fieldStyle: _react.PropTypes.object,
  inputStyle: _react.PropTypes.object,
  goeasyStyle: _react.PropTypes.object,
  value: _react.PropTypes.string,
  onChange: _react.PropTypes.func,
  formProps: _react.PropTypes.object,
  disabled: _react.PropTypes.bool,
  afterInit: _react.PropTypes.func,
  orderEvaluate: _react.PropTypes.string,
  productId: _react.PropTypes.string }, _temp);
exports.default = GoeasyInputField;
module.exports = exports['default'];


/*****************
 ** WEBPACK FOOTER
 ** ./src/components/GoeasyInputField/GoeasyInputField.js
 ** module id = 28
 ** module chunks = 0
 **/